import React from 'react';
import { CheckCircle2, AlertCircle, Wrench, RefreshCw, Info } from 'lucide-react';
export function RepairVsReplace() {
  const repairBullets = ['The chip is small and contained', "The damage is away from the driver's direct line of sight", 'The damage is away from the windshield edge', 'The damage has not spread into a crack', 'Dirt and moisture have not contaminated the damaged area'];
  const replaceBullets = ['The windshield has a crack', 'Damage is spreading', "Damage blocks or distorts the driver's view", 'Damage is near the windshield edge', 'Multiple chips or cracks are present', 'ADAS cameras or sensors may be affected'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-996" data-mp="3enm790ioznee">
      <div className="max-w-5xl mx-auto" data-id="element-997" data-mp="3irah5pusqv2t">
        <div className="text-center mb-12" data-id="element-998" data-mp="3io66qaqqn33p">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-normal leading-tight" data-id="element-999" data-mp="3nokf5tw94f29">
            Can{' '}
            <span className="text-emergencyBrand-red" data-id="element-1000" data-mp="3vw4392la6vhj">
              Emergency Windshield Damage
            </span>{' '}
            Be Repaired?
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1001" data-mp="3muw4kjeursmx">
          {/* Repair Card */}
          <div className="bg-white rounded-lg p-6 sm:p-8 border border-slate-200 shadow-sm" data-id="element-1002" data-mp="3hwbehctbepc7">
            <div className="flex items-center gap-3 mb-6" data-id="element-1003" data-mp="jcclo7i2dz4s">
              <div className="bg-emerald-50 p-3 rounded-lg" data-id="element-1004" data-mp="eeb63wjukhy2">
                <Wrench className="w-6 h-6 text-emerald-600" data-id="element-1005" data-mp="ef2zd0pz23l6" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-1006" data-mp="9m9tg9irop7i">
                Repair may be possible when…
              </h3>
            </div>
            <ul className="space-y-3.5" data-id="element-1007" data-mp="123vn49wfx54p">
              {repairBullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-1008" data-mp="125oxo0a6c9hz" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-1009" data-mp="xbknz99ixnd7" />
                  <span className="text-slate-700" data-id="element-1010" data-mp="2rm2dsbpud4qp">{bullet}</span>
                </li>)}
            </ul>
          </div>
          {/* Replace Card */}
          <div className="bg-white rounded-lg p-6 sm:p-8 border border-slate-200 shadow-sm" data-id="element-1011" data-mp="2hvfzcktv2k9l">
            <div className="flex items-center gap-3 mb-6" data-id="element-1012" data-mp="2muaqca1zff4s">
              <div className="bg-emergencyBrand-redLight p-3 rounded-lg" data-id="element-1013" data-mp="2msg7d1a9tx3c">
                <RefreshCw className="w-6 h-6 text-emergencyBrand-red" data-id="element-1014" data-mp="27vyug5mfoaeo" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-1015" data-mp="2cwd41s3onset">
                Replacement is usually safer when…
              </h3>
            </div>
            <ul className="space-y-3.5" data-id="element-1016" data-mp="1yyol4pt6evce">
              {replaceBullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-1017" data-mp="23xj3xrr58jwi" data-mpi={i}>
                  <AlertCircle className="w-5 h-5 text-emergencyBrand-red shrink-0 mt-0.5" data-id="element-1018" data-mp="3tbo7r2vz4pt6" />
                  <span className="text-slate-700" data-id="element-1019" data-mp="230lmkpwsykk">{bullet}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg p-4 flex gap-3 mb-10 max-w-3xl mx-auto" data-id="element-1020" data-mp="c5mbvmh69zdy">
          <Info className="w-5 h-5 text-slate-500 shrink-0 mt-0.5" data-id="element-1021" data-mp="l0aj3i6b5r5e" />
          <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1022" data-mp="l1ln9j3o10x1">
            A windshield chip repair is designed to help stop damage from
            spreading. It may still be visible after repair. Cracks are
            generally not repairable and usually require replacement.
          </p>
        </div>
        <div className="text-center" data-id="element-1023" data-mp="q1hojakzae8w">
          <a href="#quote" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-1024" data-mp="13zof05nllbyj">
            Request a Windshield Inspection
          </a>
        </div>
      </div>
    </section>;
}